import Direction from "./direction"

export default class DirectionRightForm extends Direction {
  protected snappableCommands(width: number, height: number, flanged: boolean): [string[], string[]] {
    const offset = this.flangedOffset

    const aw = height / 2
    const top = -(height / 2)
    const bottom = height / 2
    const left = -(width / 2)
    const right = width / 2

    const side = [this.pathMoveTo(left, bottom)]
    side.push(this.pathLineToAbs(left, top))

    const rest = [this.pathMoveTo(left, top)]

    if (height >= width * 2) {
      rest.push(this.pathLineToAbs(right, 0))
      rest.push(this.pathLineToAbs(left, bottom))
    } else {
      if (flanged) {
        // top flanged extra
        rest.push(this.pathLineToAbs(left + offset, top - offset))
        rest.push(this.pathLineToAbs(right - aw - offset, top - offset))
      }

      rest.push(this.pathLineToAbs(right - aw, top))
      rest.push(this.pathLineToAbs(right, 0))
      rest.push(this.pathLineToAbs(right - aw, bottom))

      if (flanged) {
        // bottom flanged extra
        rest.push(this.pathLineToAbs(right - aw - offset, bottom + offset))
        rest.push(this.pathLineToAbs(left + offset, bottom + offset))
      }

      rest.push(this.pathLineToAbs(left, bottom))
    }

    return [side, rest]
  }
}
